<template>
    <div class="fhv-centent" v-loading="loading">
        <h4 class="title-topic">Attack Protection Settings</h4>
        <el-form label-width="180px" label-position="left"  class="fhv-form" 
        :disabled="$G_DEVICE_CFG.isReadOnly">
            <el-form-item label="Enable :" > 
                <el-switch v-model="dosEnable" @change="dosEnableSwitch"></el-switch>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading:false,
            dosEnable: false
        }
    },
    beforeMount(){
        this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            axios
            .post("/boafrm/fhDosProtection",{CmdType:"GET_DOS"})
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                     this.dosEnable = response.data.dosEnable
                }
                else
                    this.$message.error('GET data failed!')
            })
        },
        dosEnableSwitch(){
            this.loading = true
            axios
            .post("/boafrm/fhDosProtection",{
                CmdType:"SET_DOS",
                dosEnable:this.dosEnable
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                     this.$message.success("Configuration is successful!")
                }
                else
                    this.$message.error("Configuration failed!")
            })
        }
    },
}
</script>

